import structFn from "../../struct";
import { TandemEvents } from "./TandemEvents";

const struct = structFn();

export const parseEvent = (eventId: number, payload: Uint8Array) => {
  const event = eventId in TandemEvents ? TandemEvents[eventId as keyof typeof TandemEvents] : undefined;
  if (!event) {
    return undefined;
  }

  const unpackedPayload = struct.unpack(payload, 0, event.format, event.fields);
  const parsedPayload = event.schema.safeParse(unpackedPayload);
  if (!parsedPayload.success) {
    console.warn(event.name, parsedPayload.error.issues);
    return undefined;
  }
  const finalPayload = parsedPayload.data;
  if (parsedPayload.success) {
    return {
      ...event,
      // @ts-expect-error - we know that the parsedPayload is valid for the postprocess function
      payload: event.postprocess(finalPayload),
    };
  }
  return undefined;
};
